import { Undo2 } from "lucide-react";
import { useBingoGameStore } from "@/plugins/bingo/state/bingoGameStore";
import { MAX_UNDO } from "@/plugins/bingo/engine/drawEngine";

/**
 * UndoButton: shows current undo depth vs MAX_UNDO=3.
 * Reactivity: subscribe to primitives (drawIndex, undoDepth) so the button
 * re-renders when either changes. Then re-derive canUndo synchronously.
 */
export default function UndoButton() {
  const drawIndex = useBingoGameStore((s) => s.drawIndex);
  const undoDepth = useBingoGameStore((s) => s.undoDepth);
  const undo = useBingoGameStore((s) => s.undo);

  const canUndo = drawIndex > 0 && undoDepth < MAX_UNDO;
  const disabled = !canUndo;

  return (
    <button
      data-testid="host-undo"
      type="button"
      disabled={disabled}
      onClick={undo}
      className="h-10 rounded-md text-sm border border-[color:var(--ic-border-subtle)] text-white hover:border-[color:var(--ic-border-focus)] disabled:opacity-40 inline-flex items-center justify-center gap-2"
    >
      <Undo2 className="w-4 h-4" />
      Undo Last
      <span
        data-testid="host-undo-counter"
        className="ml-1 text-[10px] tracking-widest text-[color:var(--ic-text-muted)]"
      >
        {undoDepth}/{MAX_UNDO}
      </span>
    </button>
  );
}
